const getInitialState = () => ({
  themeList: [],
  botTypeList: [],
});
export default getInitialState();
